import { render, staticRenderFns } from "./ClientsAccounts.vue?vue&type=template&id=b5608078&"
import script from "./ClientsAccounts.vue?vue&type=script&lang=js&"
export * from "./ClientsAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5608078')) {
      api.createRecord('b5608078', component.options)
    } else {
      api.reload('b5608078', component.options)
    }
    module.hot.accept("./ClientsAccounts.vue?vue&type=template&id=b5608078&", function () {
      api.rerender('b5608078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientsAccounts.vue"
export default component.exports